import $ from 'jquery';

(function ($, Drupal) {
  Drupal.behaviors.sfmkEuCookie = {
    attach: function () {
      // Add timeout to let DOM load cookie
      setTimeout(() => {
        // Cookie banner settings button toggle
        const settingsButton = $(".cookie-compliance__settings-button");
        const cookieMsg = $(".cookie-compliance__info");
        const cookiePreferences = $(".cookie-compliance-categories");

        settingsButton.once("sfmkEuCookie").on("click", function () {
          cookieMsg.addClass("inactive");
          cookiePreferences.addClass("active");
        });
      }, 200);
    },
  };
// eslint-disable-next-line no-undef
})($, Drupal);
